import { Badge, BadgeProps, Dropdown, DropdownProps, Option } from '@fluentui/react-components';

type TStatusOption<T extends string> = {
  value: T;
  label: string;
  color: BadgeProps['color'];
};

type TProps<T extends string> = Omit<
  DropdownProps,
  | 'value'
  | 'defaultValue'
  | 'selectedOptions'
  | 'defaultSelectedOptions'
  | 'multiselect'
  | 'children'
  | 'button'
  | 'onOptionSelect'
  | 'onChange'
> & {
  value: T;
  options: readonly TStatusOption<T>[];
  onChange: (value: T) => void;
};

// Keep status colors consistent with badges while retaining Dropdown's keyboard navigation and typeahead.
const RegistrationStatusDropdown = <T extends string>({ value, options, onChange, ...props }: TProps<T>) => {
  const selected = options.find((option) => option.value === value);

  return (
    <Dropdown
      {...props}
      value={selected?.label ?? value}
      selectedOptions={[value]}
      button={{
        children: (
          <Badge appearance="tint" color={selected?.color}>
            {selected?.label ?? value}
          </Badge>
        ),
      }}
      onOptionSelect={(_, data) => {
        const option = options.find((option) => option.value === data.optionValue);
        if (option) onChange(option.value);
      }}
    >
      {options.map((option) => (
        <Option key={option.value} value={option.value} text={option.label}>
          <Badge appearance="tint" color={option.color}>
            {option.label}
          </Badge>
        </Option>
      ))}
    </Dropdown>
  );
};

export default RegistrationStatusDropdown;
